import Vendors from "./Vendors";

export default Vendors;
